/**
 * A term in a tool's note (utils/tool-note.js) opens its card underneath —
 * the definition, its source and the way to the Glossary — and closes on a
 * second press or Escape; one card at a time. The glossary loads on first use.
 */

export function initTermCards() {
  const close = (note, { focus = false } = {}) => {
    const open = note.querySelector('button.term[aria-expanded="true"]');
    open?.setAttribute('aria-expanded', 'false');
    note.querySelector('.term-card')?.setAttribute('hidden', '');
    if (focus) open?.focus();
  };

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('button.term[data-term]');
    const note = btn?.closest('.tool-head__note');
    const card = note?.querySelector('.term-card');
    if (!card) return;
    const wasOpen = btn.getAttribute('aria-expanded') === 'true';
    close(note);
    if (wasOpen) return;
    const { termById, termCardHtml } = await import('./glossary.js');
    const term = termById[btn.dataset.term];
    if (!term || !btn.isConnected) return;
    card.innerHTML = termCardHtml(term);
    card.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const note = document.activeElement?.closest?.('.tool-head__note');
    if (note?.querySelector('button.term[aria-expanded="true"]')) close(note, { focus: true });
  });
}
